import React from "react";

import { RoleAIToolsPage } from "@/components/ai/RoleAIToolsPage";

export default function TeacherAITools() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-6">
      <RoleAIToolsPage
        role="teacher"
        title="AI tools for your classroom"
        description="Pick which tools show up in your Teacher Tools panel. You can change these any time."
      />
    </div>
  );
}
